import { Spinner, SpinnerSize, Tooltip } from '@blueprintjs/core';
import { UserName } from '../../UserName';
import { SmallTag } from '../../SmallTag';
import { useAssignments } from '../../../hooks/utils/useAssignments';
import { TransferButton } from '../../TransferApplication';
import { permissions } from '@axo/shared/data-access/types';
import { MarketCountryCode } from '@axo/shared/types';
import { ApplicationConditionalWrapper } from '../../ConditionalWrappers/ApplicationConditionalWrapper';
import styles from './OwnerTag.module.css';

export function OwnerTag({
  marketCountry,
  applicationID,
}: {
  marketCountry: string;
  applicationID: string;
}) {
  const {
    assignee: currentOwnerID,
    assignmentType,
    isLoading,
  } = useAssignments({
    applicationID,
    marketCountry,
  });

  return (
    <div className={styles.ownerTagContainer}>
      {isLoading && <Spinner size={SpinnerSize.SMALL} />}
      {currentOwnerID && (
        <>
          <Tooltip
            content={
              <>
                Assigned to <UserName clientID={currentOwnerID} />
              </>
            }
          >
            <SmallTag minimal icon="briefcase" intent="success">
              <UserName clientID={currentOwnerID} />
            </SmallTag>
          </Tooltip>
        </>
      )}
      <ApplicationConditionalWrapper
        whitelist={[
          {
            marketCountry: [
              MarketCountryCode.Norway,
              MarketCountryCode.Denmark,
            ],
            roles: [permissions.RoleName.Manager],
          },
        ]}
      >
        <TransferButton
          applicationId={applicationID}
          applicationOwnerId={currentOwnerID ?? undefined}
          marketCountry={marketCountry}
          assignmentType={assignmentType ?? ''}
        />
      </ApplicationConditionalWrapper>
    </div>
  );
}
